const React = require("react");
// Using CommonJS syntax because of conditional require in the PluginCard Component

const ThemeSVG = props => (
  <svg
    className="logo"
    width="100%"
    height="100%"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: `evenodd`,
      clipRule: `evenodd`,
      strokeLinejoin: `round`,
      strokeMiterlimit: `2`,
    }}
  >
    <g transform="matrix(1,0,0,1,-256,-40)">
      <g id="Website-Exportz" transform="matrix(2.08696,0,0,2.08696,256,40)">
        <rect x="0" y="0" width="23" height="23" style={{ fill: `none` }} />
        <clipPath id="_clip1z">
          <rect x="0" y="0" width="23" height="23" />
        </clipPath>
        <g clipPath="url(#_clip1z)">
          <g
            id="FRAME-FILL"
            transform="matrix(0.468972,0,0,0.459201,-119.578,-17.9456)"
          >
            <path
              d="M303,52C303,45.377 297.735,40 291.25,40L267.75,40C261.265,40 256,45.377 256,52L256,76C256,82.623 261.265,88 267.75,88L291.25,88C297.735,88 303,82.623 303,76L303,52Z"
              className="logo-frame-fill"
              style={props ? { fill: props.backgroundcolor } : {}}
            />
          </g>
          <g id="FRAME" transform="matrix(0.479167,0,0,0.479167,0,-19.2234)">
            <path
              d="M48,52C48,45.377 42.623,40 36,40L12,40C5.377,40 0,45.377 0,52L0,76C0,82.623 5.377,88 12,88L36,88C42.623,88 48,82.623 48,76L48,52ZM46,52L46,76C46,81.519 41.519,86 36,86C36,86 12,86 12,86C6.481,86 2,81.519 2,76C2,76 2,52 2,52C2,46.481 6.481,42 12,42L36,42C41.519,42 46,46.481 46,52Z"
              className="logo-frame"
              style={props ? { fill: props.color } : {}}
            />
          </g>
          <g id="FILL" transform="matrix(0.33569,0,0,0.328357,10.9352,5.24514)">
            <rect
              x="1.682"
              y="3.951"
              width="19.635"
              height="15.098"
              className="logo-color-transparency"
              style={
                props ? { fill: props.color, fillOpacity: props.opacity } : {}
              }
            />
          </g>
          <g
            id="LOGO"
            transform="matrix(0.479167,0,0,0.479167,-122.667,-19.1667)"
          >
            <path
              d="M265.244,52.654L294.756,52.654L294.756,75.346L265.244,75.346L265.244,52.654ZM279,73.346L279,65L267.244,65L267.244,73.346L279,73.346ZM292.756,65L281,65L281,73.346L292.756,73.346L292.756,65ZM267.244,54.654L267.244,63L279,63L279,54.654L267.244,54.654ZM281,54.654L281,63L292.756,63L292.756,54.654L281,54.654Z"
              className="logo-color"
              style={props ? { fill: props.color } : {}}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

exports.Logo = ThemeSVG;
